import './lib'

import 'hammerjs' ;

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { KeycloakService } from './app/keycloak.service';

if (environment.production) {
  enableProdMode();
}

// change mainUrl and nodeUrl config dynamically
declare var config;

// mainUrl が未指定の場合、現在のhostnameを設定する
if (!config.webApiDomains.main.baseUrl) {
  config.webApiDomains.main.baseUrl = window.location.protocol + '//' + window.location.host ;
}
if (!config.webApiDomains.node.baseUrl) {
  config.webApiDomains.node.baseUrl = window.location.protocol + '//' + window.location.host ;
}

let host = window.location.hostname;
let mainUrl = config.webApiDomains.main.baseUrl;
let nodeUrl = config.webApiDomains.node.baseUrl;
if (mainUrl.indexOf('$host')) {
  config.webApiDomains.main.baseUrl = mainUrl.replace('$host', host);
}
if (nodeUrl.indexOf('$host')) {
  config.webApiDomains.node.baseUrl = nodeUrl.replace('$host', host);
}


// platformBrowserDynamic().bootstrapModule(AppModule);
KeycloakService.init()
.then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule);
})
.catch(() => window.location.reload());
// .catch((aa) => {alert(aa);});



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/main.ts